<div class="table-wrap">
    <div *ngIf="showInpatientButtons()" class="quick-edit">
        <button *ngIf="!readOnly && copySource" type="button" class="primary compact right" (click)="onCopy()">{{ shiftSchedule && shiftSchedule.isWeekend ? 'Copy Weekday to Weekend' : 'Copy Weekend to Weekday' }}</button>
        <button type="button" class="primary compact right" (click)="onViewFullStaffingGrid(!isFixed)">View Full Staffing Grid</button>
    </div>  
    <table [class.title1]="jobTitles.length === 1" class="fixed" id="fixedStaffingList" class="condensed form-group">
        <thead class="fixed-header">
            <tr class="shift-block-head">
                <th class="census"></th>
                <ng-container *ngFor="let shiftBlock of shiftBlocks">
                    <th [colSpan]="jobTitles.length">{{ shiftBlock.description }}</th>
                </ng-container>
            </tr>
            <tr>
                <th class="census"></th>
                <ng-container *ngFor="let shiftBlock of shiftBlocks">
                    <th *ngFor="let jobTitle of jobTitles">
                        {{ jobTitle.abbreviation }}
                    </th>
                </ng-container>
            </tr>
        </thead>
        <tbody class="scrolling-body">
            <tr *ngFor="let row of fixedStaffingGrid">
                <td>FTE Target</td>
                <ng-container *ngFor="let cell of row; let i = index">
                    <td>
                        <smt-staffing-grid-value [(gridCell)]="row[i]" (keyPressed)="cellKeyPressed($event)" [required]="isInputRequired" [readOnly]="readOnly"></smt-staffing-grid-value>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </table>
</div>
